import ImportDragAndDrop from "../../components/ImportDragAndDrop/ImportDragAndDrop.tsx";
import { Button, Card } from "react-bootstrap";
import { DateTime } from "luxon";
import { useAppSelector } from "@/hooks/storeHooks.ts";
import { useForm } from "react-hook-form";
import { generateFileName } from "@/utils/utils.ts";
import { saveFile } from "@/utils/sharepointAPI.ts";
import "./ImportPage.css";
import DropZone from "@/components/ImportDragAndDrop/DropZone.tsx";

interface FAQFileInput {
  file: File;
  vsdlId?: number;
  belongsToFAQ?: number;
}

// VISAS ENBART I LOGISTIKPORTALEN

const FAQFileImportPage = () => {
  const latestImportDate = useAppSelector(state => state.importData.importDate);

  const { control, handleSubmit } = useForm<any>({
    mode: "onSubmit"
  });

  // Pulls numbers after "vsdlId_" and "belongsToFAQ_" (case-insensitive, any order)
  const parseIdsFromFileName = (fileName: string) => {
    const vsdlIdMatch = fileName.match(/vsdlId_(\d+)/i);
    const belongsToFAQMatch = fileName.match(/belongsToFAQ_(\d+)/i);

    const vsdlId = vsdlIdMatch ? Number(vsdlIdMatch[1]) : undefined;
    const belongsToFAQ = belongsToFAQMatch
      ? Number(belongsToFAQMatch[1])
      : undefined;

    return { vsdlId, belongsToFAQ };
  };

  const onSubmit = async (values: any) => {
    try {
      if (values.uploadedFAQFiles?.length) {
        // Create renamed File objects, but parse IDs from ORIGINAL names

        const filesWithIds: FAQFileInput[] = values.uploadedFAQFiles.map(
          (originalFile: File) => {
            const { vsdlId, belongsToFAQ } = parseIdsFromFileName(
              originalFile.name
            );

            const renamedFile = new File(
              [originalFile],
              generateFileName(originalFile.name),
              {
                type: originalFile.type
              }
            );

            return { file: renamedFile, vsdlId, belongsToFAQ };
          }
        );

        // Save each file individually so each one can carry its own IDs
        await Promise.all(
          filesWithIds.map(({ file, vsdlId, belongsToFAQ }) =>
            saveFile("FAQFiles", [file], belongsToFAQ, vsdlId)
          )
        );
      }
    } catch (error) {
      console.error("Save failed", error);
    }
  };

  return (
    <Card className="primary">
      <Card.Header>Import av VSDL data</Card.Header>
      <Card.Body>
        <div className="page-container">
          <h2>
            Här kan du importera VSDL-data. Tänk på att endast en textfil i
            formatet .txt kan laddas upp åt gången. För att säkerställa en
            smidig process stöds tyvärr inte uppladdning av flera filer
            samtidigt eller andra filformat.
          </h2>
          <div>
            <p>
              <b>Senaste importen:</b>{" "}
              {latestImportDate &&
              latestImportDate.length > 0 &&
              latestImportDate[0]?.date
                ? DateTime.fromISO(latestImportDate[0].date, {
                    zone: "Europe/Stockholm"
                  }).toFormat("yyyy-MM-dd HH:mm")
                : "Ingen tidigare import har skett"}
            </p>
          </div>
        </div>
        <ImportDragAndDrop />
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="attached-files-text">
            <h2>
              Här kan du importera filer som hör till FAQ:er i Logistikportalen.
              Ladda upp filerna här och klicka sedan på knappen för att lägga
              till dem i Logistikportalens listor.
            </h2>
          </div>
          <DropZone name="uploadedFAQFiles" control={control} />
          <div className="attached-files-btn-container">
            <Button
              className="btn btn-success"
              onClick={handleSubmit(onSubmit)}
            >
              Spara filer
            </Button>
          </div>
        </form>
      </Card.Body>
    </Card>
  );
};

export default FAQFileImportPage;
